import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[reportModuleHost]',
    standalone: false
})
export class ReportDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
